/**
 * @prettier
 */

import React from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import { ButtonV2 } from '@zola/zola-ui';
import { onboardTrackingConstants } from '@zola-helpers/client';
import arrowIcon from 'assets/images/invitations/single-sample-modal/arrow';
import { getCardCatalogBusy } from 'cards/selectors/cardCatalogSelector';
import { getMultiSampleState } from 'cards/selectors/singlesample';
import { setMultiSampleEnabled as setMultiSampleEnabledAction } from 'cards/actions/singlesample';
import ProvisionalToggle from 'cards/components/CardListing/CardListingRedesign/ProvisionalComponents/ProvisionalToggle';
import { useMobileCheck } from '../util/hooks';
import { trackEvent } from '../../../../../util/trackingHelper';
import styles from './styles.module.less';

const { BUSINESS_UNIT } = onboardTrackingConstants;

export const PLPTileBase = ({ cardType, plpBusy, multiSampleState, setMultiSampleEnabled }) => {
  if (plpBusy) {
    return null;
  }

  const isMobile = useMobileCheck();

  let titleText;

  if (isMobile && multiSampleState.enabled) {
    const { limit } = multiSampleState.count;

    titleText = <>Pick {limit} free samples</>;
  } else {
    titleText = 'Want free samples?';
  }

  const toggleElement = (
    <div className={cx(styles.toggle, styles.inline)}>
      <ProvisionalToggle
        id="multi-samples-toggle-tile"
        withIcons
        input={{
          value: multiSampleState.enabled,
          onChange: () => {
            if (!multiSampleState.enabled) {
              trackEvent('CTA Clicked', {
                business_unit: BUSINESS_UNIT.INVITATIONS,
                cta_type: 'TOGGLE',
                cta: 'PICK_FREE_SAMPLE_DESIGNS',
              });
            }
            setMultiSampleEnabled(cardType, !multiSampleState.enabled);
          },
        }}
      />
    </div>
  );

  const arrow = (
    <div className={styles.tileArrowBox}>
      <img className={styles.tileArrow} alt="" src={arrowIcon} />
    </div>
  );

  if (isMobile) {
    titleText = (
      <>
        {titleText} {toggleElement}
      </>
    );
  }

  return (
    <div className={styles.plpTileBox}>
      <div className={styles.plpTileTitle}>{titleText}</div>
      <div className={styles.plpTileListBox}>
        <ol className={styles.plpTileList}>
          {isMobile && <li>Turn on the samples toggle. {arrow}</li>}
          <li>Select up to five designs.</li>
          <li>Add a photo and your details.</li>
          <li>Get your samples (with free shipping!).</li>
        </ol>
      </div>
      {!isMobile && !multiSampleState.enabled && (
        <ButtonV2
          variant="secondary"
          onClick={() => {
            if (!multiSampleState.enabled) {
              trackEvent('CTA Clicked', {
                business_unit: BUSINESS_UNIT.INVITATIONS,
                cta_type: 'BUTTON',
                cta: 'SELECT_YOUR_DESIGNS',
              });
            }
            setMultiSampleEnabled(cardType, true);
          }}
        >
          Select your designs
        </ButtonV2>
      )}
    </div>
  );
};

export const mapStateToProps = state => ({
  plpBusy: getCardCatalogBusy(state),
  multiSampleState: getMultiSampleState(state),
});

export const mapDispatchToProps = dispatch => ({
  setMultiSampleEnabled: (cardType, enabled) =>
    dispatch(setMultiSampleEnabledAction(cardType, enabled)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PLPTileBase);



// WEBPACK FOOTER //
// ./src/cards/components/common/SingleSample/MultiSample/PLPTile.jsx